
<script>
  export let visible;
  let url = "";
  export let af = { title: "", notes: "" };
  export let name;

  let spinner = "";
  let error;
  function changed(event) {
    //console.log("changed" + event.srcElement.value, event.srcElement);
    let mediaurl = event.srcElement.value;
    let base = "https://castingwords.com/store/";
    //    base = "http://localhost:3003/store/";
    let endpoint = base + "API3/unsupported/testurl";
    //console.log(endpoint);
    if (!mediaurl || !event.srcElement.reportValidity()) {
      url = "";
      return;
    }

    spinner = true;
    var formData = new URLSearchParams();
    formData.append("url", mediaurl);
    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ", " + pair[1]);
    // }
    // const data = new URLSearchParams();
    // for (const pair of new FormData(formElement)) {
    //     data.append(pair[0], pair[1]);
    // }

    fetch(endpoint, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        //'Content-Type': 'application/json',
        // "Content-Type": "multipart/form-data"
        "Content-Type": "application/x-www-form-urlencoded"
      },
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
      body: formData // body data type must match "Content-Type" header
    })
      .then(function(response) {
        // console.log(
        //   "Success:",
        //   response,
        //   response.status,
        //   response.type,
        //   response.url,
        //   response.body
        // );
        let myHeaders = response.headers;
        // for (var pair of myHeaders.entries()) {
        //   console.log("headers" + pair[0] + ": " + pair[1]);
        // }
        if (!response.ok || myHeaders.get("content-type") == "text/html") {
          response.text().then(function(text) {
            error = text;
            spinner = false;
          });
          return;
        }
        response.json().then(function(json) {
          //console.log("json", json);
          if (!json.ok) {
            error = json.message;
            spinner = false;
            return;
          }

          if (af.title) {af.title +=" ";}else{af.title ="";}
          if (af.notes) {af.notes +=" ";}else{af.notes ="";}

          url = mediaurl;
          af.url = mediaurl;
          if (json.title) {af.title += json.title;}
          if (json.notes) {af.notes += json.notes;}
          spinner = false;
          error = "";
            console.log("URL done2", url, af, af.duration, af.title, visible);
        });
      })
      .catch(function(error) {
        console.log("URL Error!!1", error);
        error = error;
        spinner = false;
      });

    //
  }
</script>

<style>

 @-webkit-keyframes spinner-border {
     to {
         -webkit-transform: rotate(360deg);
         transform: rotate(360deg)
     }
 }

 @keyframes spinner-border {
     to {
         -webkit-transform: rotate(360deg);
         transform: rotate(360deg)
     }
 }
 .spinner-border {
     display: inline-block;
     width: 2rem;
     height: 2rem;
     vertical-align: text-bottom;
     border: .25em solid currentColor;
     border-right-color: transparent;
     border-radius: 50%;
     -webkit-animation: spinner-border .75s linear infinite;
     animation: spinner-border .75s linear infinite;
 }
 .sr-only {
     position: absolute;
     width: 1px;
     height: 1px;
     padding: 0;
     overflow: hidden;
     clip: rect(0,0,0,0);
     white-space: nowrap;
     border: 0;
 }
  .with-spinner > .form-group {
    width: 80%;
    display: inline-block;
  }
  .spinner-border {
    display: inline-block;
    margin-right: 10px;
  }
  .error {
    color: red;
  }
</style>

<div class="urlupload {visible ? '' : 'hidden'} {spinner ? 'with-spinner' : ''}">
  <div class="spinner-border text-primary {spinner ? '' : 'hidden'}" role="status" >
     <span class="sr-only">Loading...</span>
  </div>
   <div class="form-group ">
			<label for="title">URL 
      <i class='fa fa-times-circle text-danger {error ? '' : 'hidden'}'></i>
      <span class="{url ? '' : 'hidden'}"><i class="fa fa-check-circle"></i></span> 
</label>
			<input class="form-control" type="url" id="url" name="{name}.url" value="{af.url}" autocomplete="ON"  
       placeholder="https://example.com"
       pattern="^(https?://).*"
       on:change={changed}       />
	</div>
  <div class="error {error ? '' : 'hidden'}">
    <h5 class='urlerror'>Ooops! We had a problem with your URL</h5>
    <p>{error}</p>
  </div>
</div>
